import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getErrorMessage } from "../../../api";
import {
  getDataBookingSeatApi,
  getSegmentBookingSeatApi,
  postMoveBookingSeatApi,
} from "../../../api/booking";
import { Toast } from "../../../config/constant";
import {
  DataBookingSeatParams,
  DataSegmentBookingParams,
  MoveBookingSeatParams,
  MoveBookingSeatState,
} from "../../../types/booking";
import { RootState } from "../../store";
import { setToast } from "../toastNotifySlice";

export const postMoveBooking = createAsyncThunk(
  "admin/bookings/postMoveBooking",
  async (params: MoveBookingSeatParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await postMoveBookingSeatApi(params);
      const { data, status } = response;
      if (status) {
        dispatch(setPostMoveBooking({ status: status, data: data }));
        dispatch(
          setToast({
            message: "Chuyển vé thành công",
            status: true,
            type: Toast.TYPE_SUCCESS,
          })
        );
      }
      return true;
    } catch (error: any) {
      const { response } = error;
      dispatch(
        setToast({
          message: response?.data?.message,
          status: true,
          type: Toast.TYPE_ERROR,
        })
      );
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getDataBookingSeat = createAsyncThunk(
  "admin/bookings/getDataBookingSeat",
  async (params: DataBookingSeatParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await getDataBookingSeatApi(params);
      const { data, status } = response;
      if (status) {
        dispatch(setListDataBooking(data));
      }
      return true;
    } catch (error: any) {
      const { response } = error;
      dispatch(
        setToast({
          message: response?.data?.message,
          status: true,
          type: Toast.TYPE_ERROR,
        })
      );
      return rejectWithValue(getErrorMessage(error));
    }
  }
);
export const getSegmentDataBooking = createAsyncThunk(
  "admin/bookings/getSegmentDataBooking",
  async (params: DataSegmentBookingParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await getSegmentBookingSeatApi(params);
      const { data, status } = response;
      if (status) {
        dispatch(setListDataSegment(data));
      }
      return true;
    } catch (error: any) {
      const { response } = error;

      dispatch(
        setToast({
          message: response?.data?.message,
          status: true,
          type: Toast.TYPE_ERROR,
        })
      );
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const moveBookingSlice = createSlice({
  name: "moveBookingSeat",
  initialState: {
    error: false,
    loading: false,
    loadingCreate: false,
    success: false,
    status: 0,
    statusMove: 0,
    message: "",
    errorDetail: null,
    listDataBookingSeat: [],
    listSegmentBooking: [],
  } as MoveBookingSeatState,
  reducers: {
    setListDataBooking: (state: MoveBookingSeatState, { payload }) => {
      state.listDataBookingSeat = payload?.data;
      state.status = payload?.status;
    },
    setListDataSegment: (state: MoveBookingSeatState, { payload }) => {
      state.listSegmentBooking = payload?.data;
      state.status = payload?.status;
    },
    setPostMoveBooking: (state: MoveBookingSeatState, { payload }) => {
      state.statusMove = payload?.status;
    },
    resetPostMoveBooking: (state: MoveBookingSeatState) => {
      state.statusMove = 0;
      state.message = "";
      state.loadingCreate = false;
      state.listDataBookingSeat = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postMoveBooking.pending, (state: MoveBookingSeatState) => {
      state.loadingCreate = true;
      state.success = false;
    });
    builder.addCase(
      postMoveBooking.fulfilled,
      (state: MoveBookingSeatState) => {
        state.loadingCreate = false;
        state.success = true;
        state.error = false;
      }
    );
    builder.addCase(
      postMoveBooking.rejected,
      (state: MoveBookingSeatState, actions) => {
        state.loadingCreate = false;
        state.success = false;
        state.error = true;
      }
    );
    builder.addCase(
      getSegmentDataBooking.pending,
      (state: MoveBookingSeatState) => {
        state.loading = true;
        state.success = false;
      }
    );
    builder.addCase(
      getSegmentDataBooking.fulfilled,
      (state: MoveBookingSeatState) => {
        state.loading = false;
        state.success = true;
        state.error = false;
      }
    );
    builder.addCase(
      getSegmentDataBooking.rejected,
      (state: MoveBookingSeatState, actions) => {
        state.loading = false;
        state.success = false;
        state.error = true;
      }
    );
    builder.addCase(
      getDataBookingSeat.pending,
      (state: MoveBookingSeatState) => {
        state.loading = true;
        state.success = false;
      }
    );
    builder.addCase(
      getDataBookingSeat.fulfilled,
      (state: MoveBookingSeatState) => {
        state.loading = false;
        state.success = true;
        state.error = false;
      }
    );
    builder.addCase(
      getDataBookingSeat.rejected,
      (state: MoveBookingSeatState, actions) => {
        state.loading = false;
        state.success = false;
        state.error = true;
      }
    );
  },
});

export const moveBookingSelector = (state: RootState) => state.moveBooking;
export const {
  setListDataBooking,
  setListDataSegment,
  setPostMoveBooking,
  resetPostMoveBooking,
} = moveBookingSlice.actions;
